import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import '@/index.css';

// StrictMode is kept from v2. Every effect below is written to be idempotent
// with a real cleanup, so its double-mount in development is safe.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
